import { LoyaltyProgramMetaData } from '@app/resources/services';
import { EntityState } from '@ngrx/entity';

export interface LoyaltyProgramState extends EntityState<LoyaltyProgramMetaData> {}
